import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

function Courses() {
  const [open, setOpen] = useState(false);
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: 'Full Stack Web Development',
      duration: '6 months',
      price: 599,
      level: 'Intermediate',
    },
    {
      id: 2,
      title: 'Data Science & Machine Learning',
      duration: '4 months',
      price: 699,
      level: 'Advanced',
    },
  ]);

  const [newCourse, setNewCourse] = useState({
    title: '',
    duration: '',
    price: '',
    level: 'Beginner',
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    setNewCourse({
      ...newCourse,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    setCourses([...courses, { ...newCourse, id: courses.length + 1 }]);
    setOpen(false);
    setNewCourse({
      title: '',
      duration: '',
      price: '',
      level: 'Beginner',
    });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Courses Management</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleClickOpen}
        >
          Add Course
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Price ($)</TableCell>
              <TableCell>Level</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courses.map((course) => (
              <TableRow key={course.id}>
                <TableCell>{course.title}</TableCell>
                <TableCell>{course.duration}</TableCell>
                <TableCell>${course.price}</TableCell>
                <TableCell>{course.level}</TableCell>
                <TableCell>
                  <Button color="primary">Edit</Button>
                  <Button color="error">Delete</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New Course</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="title"
            label="Course Title"
            fullWidth
            variant="outlined"
            value={newCourse.title}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            name="duration"
            label="Duration"
            fullWidth
            variant="outlined"
            value={newCourse.duration}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            name="price"
            label="Price"
            type="number"
            fullWidth
            variant="outlined"
            value={newCourse.price}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            name="level"
            select
            label="Level"
            fullWidth
            variant="outlined"
            value={newCourse.level}
            onChange={handleInputChange}
          >
            <MenuItem value="Beginner">Beginner</MenuItem>
            <MenuItem value="Intermediate">Intermediate</MenuItem>
            <MenuItem value="Advanced">Advanced</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            Add Course
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Courses;
